module.exports = __webpack_public_path__ + "img/sssd.367fe804.jpg";